import { lmsClient } from "api";

const buildGlJournalQueryBuilderParams = (data = {}) => {
  const params = new URLSearchParams();
  params.append("pageIndex", data.pageIndex ?? 0);
  params.append("pageSize", data.pageSize ?? 1000);
  params.append("queryBuilderId", data.queryBuilderId || "");
  params.append("tablename", data.tablename || "");
  return params.toString();
};

const GlJournalQueryBuilderService = {};

GlJournalQueryBuilderService.getGlJournalQueryBuilderList = function (data = {}) {
  return lmsClient({
    url: `/lms/GlJournalQueryBuilder/search?${buildGlJournalQueryBuilderParams(data)}`,
    method: "get",
  });
};

GlJournalQueryBuilderService.addGlJournalQueryBuilder = function (data) {
  return lmsClient({
    url: `/lms/GlJournalQueryBuilder/add`,
    method: "post",
    data,
  });
};

export default GlJournalQueryBuilderService;
